import React, { FC } from "react"
import Modal from "react-bootstrap/cjs/Modal"
import { authContext } from "../context/auth/authContext"
import { Button } from "react-bootstrap"

const ForbiddenModal: FC<any> = () => {
  const context = React.useContext(authContext)
  return (
    <Modal
      show={context.isForbidden}
      onHide={() => {
        context.logout()
      }}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="text-danger">
          <h5>Authentication Error!</h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        You no longer have access to this page. Kindly login again to proceed
        further. {"   "}
        <Button
          variant="success"
          onClick={() => {
            context.logout()
          }}
        >
          Go to Login
        </Button>
      </Modal.Body>
    </Modal>
  )
}

export default ForbiddenModal
